import React, { useState,useEffect,useContext,useRef,useMemo } from "react"
import studylistContext from "./StudylistContext";
import { data } from "./Studylistdata";
import { StudyListColumns } from "../../constants/Columns/StudyList";
import { assignMe, batchDeleteStudyApi, batchReinferenceStudyApi, downloadCompletedCsvFile, downloadCompletedExcelFile, fetchCsvDownloadProgress, fetchExcelDownloadProgress, getStudyList, getStudyListByTab, getStudyListWithContextSwitch,  returnedStudyCountApi,getAssignmentStausCount,fetchpendingrequestcount, initiateBulkDownload } from "../../service/StudyListService";
import userContext from "../users/UserContext";
import loaderContext from "../loader/LoaderContext";
import { t } from "i18next";
import { CXR_TABS, MODAL_TYPE, TAB_NAME, TOAST_TYPE, USERTYPES , NO_OF_IMAGES_STATUS, REINFERECE_ALLOWED_MODALITY, PEER_REVIEW_TABS, QC_REVIEW_TABS, DEFAULT_SORT_COLUMNS, ARCHIVED_STUDY_TABS, SAVED_TABS, REPORTED_TABS, REPORTED_SUBTABS_ID, AuthRoutes} from "../../constants/Constants";
import { initPaginationData, tabDetails } from "../../pages/StudyList/helpers/initData";
import themeContext from "../theme/ThemeContext";
import { handleCXRBorderChange, handleSucessDataAndCount, updateDto, TABS_WITH_SPECIFIC_SORT } from "../../pages/StudyList/helpers/helpingFunctions";
import { getCurrentActiveTabId } from "../../pages/StudyList/helpers/mobileUtilities";
import toastContext from "../toast/ToastContext";
import Moment from "moment";
import { isMobile } from "react-device-detect";
import { getStudyCounts } from "../../service/AnalyticsService";
import { getEnv } from '../../helpers/EnvHelper';
import { getRadiologistDisplayName } from "../../helpers/CommonUtility";
export const initSearchDto = {
    patientId: null,
    patientName: null,
    modalityId: null,
    clientOrFirmIds: null,
    uploadDate: null,
    studyDateFrom : null,
    studyDateTo : null,
    annotationId : null,
    aiPredictionId: null,
    providerIds : null,
    modalityIds : null,
    subModalityIds: null,
    activeTab : null,
    start : null,
    firmId: null,
    emailId: null,   
    patientNameOrId: null,
    testName: null,
    orderId: null,
    accessionNumber: null,
    studyDescription: null,
    keyword: null,
    noOfImages: null,
    historyChecks: null,
    reportDateFrom: null,
    reportDateTo: null,
    classificationIds:null
  };

const StudylistState = (props) => {
  
    const queryString = window.location.search;
    // Create a URLSearchParams object
    const urlParams = new URLSearchParams(queryString);

    // Get a specific query parameter
    const clientId = urlParams.get('clientId');
    const secretKey = urlParams.get('secretKey');
    const patientId = urlParams.get('patientId');

    const { roles, authenticated, loadByUsername, userId,username, contextSwitchUser,qcReviewer, qcOutsourceLogin, isActiveData, peerReviewAdmin, peerReviewEvaluator } =
    useContext(userContext);
    const { ref, setLoaderRunning,setShowModal, showModal } = useContext(loaderContext);
    const { showToastv2, updateToastv2, list, setList, updateProgress, hideProgress } =
    useContext(toastContext);
    const {themeName,setShowLightTheme} = useContext(themeContext);

    const [sortGlobal, setSortGlobal] = useState({
        sortColumn : "assignment_created_date",
        sortOrder : "desc"
    });
    const [changeToDropSorting, setChangeToDropSorting] = useState(false);
    const studyListRef = useRef(null);
    const [filterInputValues,setFilterInputValues] = useState(null);
    const [storefilterInputValues,setStoreFilterInputValues] = useState({});
    const [showFilters, setShowFilters] = useState(false);
    const [filterBadges,setFilterBadges] = useState([]);
    const [storefilterBadges,setStoreFilterBadges] = useState([]);
    const [clientFirmList,setClientFirmList] = useState([]);
    const [fullClientFirmList,setFullClientFirmList] = useState([]);
    const [minimalClientFirmList,setMinimalClientFirmList] = useState([]);
    const [returnedReasonCount, setReturnedReasonCount] = useState([]);
    const [dataQueryState, setDataQueryState] = useState();
    const [trackApplyButton,setTrackApplyButton] = useState(true);
    const [patientNameBadgeShow,setPatientNameBadgeShow] = useState(false);
    const [showCommunicationModal, setShowCommunicationModal] = useState({studyId:null,show:false,child:false});
    const [showReturnedStudyReasonModal, setShowReturnedStudyReasonModal] = useState({studyId:null,show:false});
    const [showVersionModalForReport,setShowVersionModalForReport] = useState({show:false,data:[]});
    const [showCount, setShowCount] = useState(true);
    const [studyListLoading, setStudyListLoading] = useState(true);
    const [firstTimeLoad,setFirstTimeLoad] = useState(false);
    const [firstTimeLoading,setFirstTimeLoading] = useState(true);
    const [showShimmer,setShowShimmer] = useState(true);
    const [updateLockUnlockRows, setUpdateLockUnlockRows] = useState(false);
  const [storedRows, setStoredRows] = useState({ "unreported": { pageIndex: 0, pageSize: 50, rows: null, totalCount: 0 } });
  const [totalRecordCount, setTotalRecordCount] = useState({});
  const [activeTab, setActiveTab] = useState("");
    const [showClientName, setShowClientName] = useState(false);
    const [showViewer, setShowViewer] = useState(false);
    const [showAiResults, setShowAiResults] = useState(false);
    const [showSavedReport, setShowSavedReport] = useState(false);
    const [twoMonitorEnabled, setTwoMonitorEnabled] = useState(false);
    const [studyListModalAuditEnabled, setStudyListModalAuditEnabled] = useState(false);
    const [showAddStudy, setShowAddStudy] = useState(false);
    const [showChats, setShowChats] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const [positive, setPositive] = useState(false);
    const [showReferringPhysician, setShowReferringPhysician] = useState(false);
    const [isTypistWorkflowEnabled, setIsTypistWorkflowEnabled] = useState(false);
    const [enableHistoryUpload, setEnableHistoryUpload] = useState(false);
    const [allowDeleteStudy, setAllowDeleteStudy] = useState(false);
    const [searchResultLength, setSearchResultLength] = useState(0);
    const [searchResultLengthObj,setSearchResutLengthObj] = useState({
        len : 0
    });
    const [providerDdlList,setProviderDdlList] = useState({});
    const [showGenericConfirmModal, setShowGenericConfirmModal] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showImageDeleteModal, setShowImageDeleteModal] = useState(false);
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
    const [showDeleteSuccessModal, setShowDeleteSuccessModal] = useState(false);
    const [showReInferenceModal, setShowReInferenceModal] = useState(false);
    const [rowSelectionState, setRowSelectionState] = useState({});
    const [rowSelectedArray,setRowSelectedArray] = useState([]);
    const [showConfirmModalState, setShowConfirmModalState] = useState(false);
    const [runBatchDelete, setRunBatchDelete] = useState(false);
    const [selectedValue, setSelectedValue] = useState("study_1");
    const [filterApplied,setFilterApplied] = useState(0);
    const [assignmentChaiHoverPopupId,setAssignmentChaiHoverPopupId] = useState(null);
    const [alertSuccessStudyListState, setAlertSuccessModalStudyListState] = useState({
        show: false,
        isError: false,
        isWarning: false,
        isSuccess: false,
        heading: "",
        description: "",
      });
    const [batchReinferenceAndDeleteArray, setBatchReinferenceAndDeleteArray] = useState({
        batchDelete: null,
        batchImageDelete: null,
        batchInference: null,
        batchDeleteCount: 0,
        batchDeleteImageCount:0,
        batchInferenceCount: 0
    });
    const [resetRowSelection,setResetRowSelection] = useState(false);
    const [paginationObj, setPaginationObj] = useState(initPaginationData);
    const [showSendReportModal,setShowSendReportModal] = useState({
      show: false,
      firmId: null,
      clientId: null
    })
    const [studyDateFrom,setStudyDateFrom] = useState(isMobile?null:new Date());
    const [studyDateTo,setStudyDateTo] = useState(isMobile?null:new Date());
    const [filterValueFetchStarted, setFilterValueFetchStarted] = useState(null);
    const [studyCsvProgress, setStudyCsvProgress] = useState(0);
    const [studyCsvProgressId, setStudyCsvProgressId] = useState(0);
    const [csvToken, setCsvToken] = useState("");
    const [csvFetchInterval, setCsvFetchInterval] = useState(0);
    const [exportType, setExportType] = useState("csv");
    const [showExportCsvModal, setShowExportCsvModal] = useState(false);
    const [showDownloadsModal, setShowDownloadsModal] = useState(false);
    const [showAddStudyModal, setShowAddStudyModal] = useState(false);
    const [showExportCsvConfirmModal, setShowExportCsvConfirmModal] = useState(false);
    const [noOfImagesFilter, setNoOfImagesfilter] = useState(null);
    const [preferenceNoOfImagesFilter, setPreferenceNoOfImagesFilter] = useState(null);
    const [historyCheckFilter, setHistoryCheckFilter] = useState(0);
    const [mobileAssignmentObject, setMobileAssignmentObject] = useState({showProviderFilter:false,index:null,data:null});
  const [allDataElement, setAllDataElement] = useState([]);
  const [runPaginationAlgo, setRunPaginationAlgo] = useState(false);
    const [reportDateFrom,setReportDateFrom] = useState(new Date());
    const [reportDateTo,setReportDateTo] = useState(new Date());
  const [studyListSearchDateFilterValue, setStudyListSearchDateFilterValue] = useState(1);

    useEffect(() => {
      if (!REPORTED_SUBTABS_ID.includes(selectedValue)) {
        setReportDateFrom( new Date());
        setReportDateTo( new Date());
        setFilterBadges((current) =>
          current.filter((item) => item.key !== "reportDateFrom" && item.key !== "reportDateTo")
        );
        setSearchDto((prev) => ({ ...prev, reportDateFrom: null, reportDateTo: null }));
      }
    }, [selectedValue]);
  const [studylistOrderBy, setStudylistOrderBy] = useState(1); // Default to 1 (Assigned On)
  const[customDateFilter,setCustomDateFilter]=useState(0);
  const [imageUploadStatusMap, setImageUploadStatusMap] = useState({});
  const [allowStudyEdit, setAllowStudyEdit] = useState(false);

  const [refreshRequired, setRefreshRequired] = useState({
    unreported : {id:"unreported",alreadyLoaded: false},
    draft :  {id:"draft",alreadyLoaded: false},
    saved :  {id:"saved",alreadyLoaded: false},
    reviewPending:  {id:"reviewPending",alreadyLoaded: false},
    reported : {id:"reported",alreadyLoaded: false},
    closed : {id:"closed",alreadyLoaded: false},
    qcreview : {id:"qcreview",alreadyLoaded: false},
    qcreviewAssigned : {id:"qcreviewAssigned",alreadyLoaded: false},
    qcfix :  {id:"qcfix",alreadyLoaded: false},
    qcverify :  {id:"qcverify",alreadyLoaded: false},
    returned : {id:"returned",alreadyLoaded: false},
    critical : {id:"critical",alreadyLoaded: false},
    library:  {id:"library",alreadyLoaded: false},
    normal:  {id:"normal",alreadyLoaded: false},
    normalwithfb:  {id:"normalwithfb",alreadyLoaded: false},
    abnormal:  {id:"abnormal",alreadyLoaded: false},
    reviewAssigned:  {id:"reviewAssigned",alreadyLoaded: false},
    reviewComplete:  {id:"reviewComplete",alreadyLoaded: false},
    evaluationAssigned:  {id:"evaluationAssigned",alreadyLoaded: false},
    evaluationComplete:  {id:"evaluationComplete",alreadyLoaded: false},
    pending: {id:"pending",alreadyLoaded: false},
    approved: {id:"approved",alreadyLoaded: false},
    rejected: {id:"rejected",alreadyLoaded: false},
    positive: {id:"positive",alreadyLoaded: false},
    negative: {id:"negative",alreadyLoaded: false},
  })

  const [unreportedAllTabs,setUnreportedAllTabs] = useState({
    data : {
        tabId:"study_1",
        id:"unreported",
        title: "Unreported"
  }});
  const [tabBadgeState, setTabBadgeState] = useState({
    unreported: { id: "unreported", showBadge: false, value: null },
    draft: { id: "draft", showBadge: false, value: null },
    saved: { id: "saved", showBadge: false, value: null },
    reviewPending: { id: "reviewPending", showBadge: false, value: null },
    reported: { id: "reported", showBadge: false, value: null },
    closed: { id: "closed", showBadge: false, value: null },
    qcreview : {id:"qcreview",showBadge: false, value: null},
    qcreviewAssigned : {id:"qcreviewAssigned",showBadge: false, value: null},
    qcfix:{id:"qcfix",showBadge: false, value: null},
    qcverify : {id:"qcverify",showBadge: false, value: null},
    returned : {id:"returned",showBadge: false, value: null},
    critical : {id:"critical",showBadge: false, value: null},
    library:  {id:"library",showBadge: false, value: null},
    reviewAssigned: { id: "reviewAssigned", showBadge: false, value: null },
    reviewComplete: { id: "reviewComplete", showBadge: false, value: null },
    archivedStudyRequest:{id:"archivedStudyRequest",showBadge: false, value: null},
    pending:{id:"pending",showBadge: false, value: null},
    approved:{id:"approved",showBadge: false, value: null},
    rejected:{id:"rejected",showBadge: false, value: null}


  });
  const [studyListReloadCounter, setStudyListReloadCounter] = useState(0);

  const [peerReviewAssignedTab, setPeerReviewAssignedTab] = useState({
    data : {
        tabId: !peerReviewAdmin && peerReviewEvaluator ? "study_16" : "study_14",
        id: !peerReviewAdmin && peerReviewEvaluator ? "evaluationAssigned" : "reviewAssigned",
        title: !peerReviewAdmin && peerReviewEvaluator ? "Evaluation Assigned" : "Review Assigned"
  }});

  const [archivedStudyRequestTab, setArchivedStudyRequestTab] = useState({
    data : {
        tabId: "study_18",
        id: "archivedStudyRequest",
        title: "archivedStudyRequest"
  }});

  const [savedAllTabs, setSavedAllTabs] = useState({
    data : {
        tabId: "study_2",
        id: "saved",
        title: "saved"
  }});

  const [reportedAllTabs, setReportedAllTabs] = useState({
    data : {
        tabId: "study_3",
        id: "reported",
        title: "Reported"
  }});

  const [qcReviewAllTabs, setQcReviewAllTabs] = useState({
    data : {
        tabId: "study_24",
        id: "qcreviewAssigned",
        title: "Assigned to Me"
  }});

    const [pageGlobal,setPageGlobal] = useState({
        unreported : {
            pageIndex: 0, 
            pageSize: 50 
        }
    });

    const [trackOfVisisted, setTrackOfVisited] = useState([]);

    //studyListSearchDto
    const [searchDto, setSearchDto] = useState(initSearchDto);

    const [statePagination, setStatePagination] = useState({
        unreported : {
            unreportedStudiesPage : 1,
            pageSize : 50
        },
        saved : {
            savedStudiesPage : 1,
            pageSize : 50
        }
    })

    const [selectedStudies, setSelectedStudies] = useState([]);//studyids-selected
    // const [selectedAllStudies, setSelectedAllStudies] = useState(false);
    const [studyData, setStudyData] = useState(data.data);
    const [allStudies, setAllStudies] = useState();
    const [applyClick,setApplyClick] = useState(false);
    // const addAllStudies = (list) => {
    //     setSelectedStudies(list);
    // }
    const [maintenance, setMaintenance] = useState({});

    // const [studyCounts, setStudyCounts] = useState({
    //   totalStudies: 0,
    //   totalReported: 0,
    //   totalUnreported: 0,
    //   totalAssigned: 0,
    //   totalLockedByYou: 0
    //   });
    const [studyCounts, setStudyCounts] = useState(null);

    const [maxBulkReportDownload, setMaxBulkReportDownload] = useState(0);
    const [xrayReportType, setXrayReportType] = useState("pdf");
    const [nonXrayReportType, setNonXrayReportType] = useState("pdf");

    const [studyBlitzFilter, setStudyBlitzFilter] = useState("any");

    useEffect(()=>{
      if(roles[0] == USERTYPES.SUPERVISOR && qcOutsourceLogin){
        setSelectedValue("study_24")
      }
    }, [roles])

    const uploadDateRange = [
        {key: "0", text: t("study-list.filters.today"), name: "Today"},
        { key: "1", text: t("study-list.filters.last-1-day"),name: "Last 1 Day" },
        { key: "2", text: t("study-list.filters.last-2-day"), name: "Last 2 Day" },
        { key: "7", text: t("study-list.filters.last-1-week"), name: "Last 1 Week" },
        { key: "14", text: t("study-list.filters.last-2-week"), name: "Last 2 Weeks" },
        { key: "30", text: t("study-list.filters.last-1-month"), name: "Last 1 Month" },
        { key: "365", text: t("study-list.filters.last-1-year"), name: "Last 1 Year" } 
      ];
    // const [studyCounts, setStudyCounts] = useState({
    //     totalStudies: 0,
    //     totalReported: 0,
    //     totalUnreported: 0,
    //     totalAssigned: 0,
    //     totalLockedByYou: 0
    // });
    const [studyCountLoading, setStudyCountLoading] = useState(true);

    useEffect(() => {
      const isVdcPlatform = getEnv("REACT_APP_VDC_PLATFORM") === "true" || getEnv("REACT_APP_VDC_PLATFORM") === true;
      const isBlitzSession = window.location.pathname === AuthRoutes.BLITZREPORTING
      if (isVdcPlatform || isBlitzSession) {
        return; // Skipping API call if VDC platform is ON
      }
      const fetchStudyCounts = async () => {
        setStudyCountLoading(true);  // Showing loader before api call
          try {
            const response = await getStudyCounts(true);
            if (response?.data) {
    
                  setStudyCounts({
                      totalStudies: response.data.data.totalStudies || 0,
                      totalReported: response.data.data.totalReported || 0,
                      totalUnreported: response.data.data.totalStudies - response.data.totalReported || 0,
                      totalAssigned: response.data.data.totalAssigned || 0,
                      totalLockedByYou: response.data.data.totalSelfLocked || 0
                  });
              } else {
              }
          } catch (error) {
              console.error("Error fetching study counts:", error);
          } finally {
            setStudyCountLoading(false);
          }
      };
    
      fetchStudyCounts();
    }, []);

    useEffect(()=>{
        if(firstTimeLoad){
            setStoreFilterBadges(filterBadges);
            let filterUpdated = filterApplied + 1;
            setFilterApplied(filterUpdated);
        }
    },[firstTimeLoad]);

    const prevFirstTimeLoadingRef = useRef(true);
    useEffect(() => {
        if (prevFirstTimeLoadingRef.current === true && firstTimeLoading === false) {
            setFilterApplied(prev => prev + 1);
        }
        prevFirstTimeLoadingRef.current = firstTimeLoading;
    }, [firstTimeLoading]);

    useEffect(() => {
      if (csvToken === "") return;

      const zipProgressInterval = setInterval(async () => {
        const progress = await fetchCsvDownload();
        if (progress >= 100) {
          clearInterval(zipProgressInterval);
        }
      }, csvFetchInterval || 2000);

      return () => {
        clearInterval(zipProgressInterval);
      };
    }, [csvToken]);

    useEffect(() => {
      setStoreFilterBadges(filterBadges);
    }, [filterBadges])

    useEffect(() => {
      if (roles[0] === USERTYPES.RADIOLOGIST) {
        if (customDateFilter === -1) {
          if (searchDto.uploadDate) {
            setSearchDto(prev => ({ ...prev, uploadDate: null }));
            setFilterBadges(prev => prev.filter(badge => badge.key !== "uploadDate"));
          }
        }
          else if (getEnv("REACT_APP_VDC_PLATFORM") === "true") {
            setUploadDate({
              key: "14",
              text: "Last 2 Weeks",
            });
          } else if (customDateFilter != 0) {
            let selectedFilter = "";
            uploadDateRange.map((ele) => {
              if (ele.key == customDateFilter) {
                selectedFilter = ele.name;
              }
            });
            if (selectedFilter != null || selectedFilter != "") {
              setUploadDate({
                key: customDateFilter,
                text: selectedFilter,
              });
            } else {
              if (isActiveData) {
                setUploadDate({
                  key: "2",
                  text: "Last 2 Days",
                });
              }
            }
          } else {
            if (isActiveData) {
              setUploadDate({
                key: "2",
                text: "Last 2 Days",
              });
            }
          }

        setFirstTimeLoad(true);
      } else if((getEnv("REACT_APP_VDC_PLATFORM") === "true" || getEnv("REACT_APP_VDC_PLATFORM") === true) && (roles[0] === USERTYPES.FIRMTECHNICIAN || roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR)){
        setUploadDate({
          "key": "30",
          "text": "Last 1 Month"
        });
        setFirstTimeLoad(true);
      } else if (roles[0] !== USERTYPES.RADIOLOGIST) {
        // console.log("--- Else Setting Last 2 days ----");
        setFilterBadges([]);
        setStoreFilterBadges([]);
        setSearchDto(initSearchDto);
        setFirstTimeLoad(false);
      }
    }, [roles[0], customDateFilter]);

      useEffect(() => {
        setFilterBadges(prev => {
          const withoutNoOfImages = prev.filter(b => b.key !== "noOfImages");
          if (searchDto.noOfImages == null || searchDto.noOfImages === undefined) {
            return withoutNoOfImages;
          }
          const label = searchDto.noOfImages === NO_OF_IMAGES_STATUS.ZERO_NO_OF_IMAGES ? "0" : "> 0";
          return [...withoutNoOfImages, { key: "noOfImages", label, value: searchDto.noOfImages }];
        });
      }, [searchDto.noOfImages]); 

    useEffect(()=>{

      setList([]);
      const tabArray = tabDetails(roles, selectedValue, themeName, unreportedAllTabs, peerReviewAssignedTab, contextSwitchUser, qcReviewer, qcOutsourceLogin, peerReviewAdmin, peerReviewEvaluator, archivedStudyRequestTab, savedAllTabs, reportedAllTabs, qcReviewAllTabs);
      // If the tab array doesn't have an entry matching the selectedValue (e.g. non-FAHES
      // Reported subtabs where the tab id is hardcoded as "study_3"), map to the parent
      // Reported tab id so getCurrentActiveTabId can find it and return the correct tabNameId.
      const tabExists = tabArray.some(t => t.id === selectedValue);
      const lookupId = !tabExists && REPORTED_SUBTABS_ID.includes(selectedValue) ? "study_3" : selectedValue;
      setActiveTab(getCurrentActiveTabId(tabArray, lookupId));
    },[selectedValue])

    // Set default sort based on user preference for tabs that don't have their own sort column
    useEffect(() => {
      if(!TABS_WITH_SPECIFIC_SORT.includes(selectedValue) && studylistOrderBy) {
        let defaultSortColumn = "";
        let defaultSortOrder = "desc";
        
        if(studylistOrderBy === 2) {
          defaultSortColumn = "emergency_status";
        } else if(studylistOrderBy === 1) {
          defaultSortColumn = "assignment_created_date";
        }
        
        
        if(defaultSortColumn !== "") {
          setSortGlobal((prev) => {
            const isCurrentSortDefault = prev.sortColumn === "assignment_created_date" || prev.sortColumn === "emergency_status";
            if (isCurrentSortDefault) {
              return { sortColumn: defaultSortColumn, sortOrder: defaultSortOrder };
            }
            return prev;
          });
        }
      }
    }, [selectedValue, studylistOrderBy])

    useEffect(() => {
      setResetRowSelection(true);
      const fetchData = async () => {
        try {
          const response = await getAssignmentStausCount();
         if(response.status==200)
         updateTabBadge("reviewAssigned",response.data.data.count);
         updateTabBadge("reviewComplete",response.data.data.count);
        } catch (error) {
          console.error("Error fetching assignment status count:", error);
        }
      };
      if (roles[0] == USERTYPES.RADIOLOGIST && getEnv("REACT_APP_VDC_PLATFORM")=="true") 
          fetchData();
      if (roles[0]== USERTYPES.FIRMADMIN && getEnv("REACT_APP_VDC_PLATFORM")=="true")
        fetchPendingRequestCountData();
    }, [studyListReloadCounter]);
    
    const fetchPendingRequestCountData= async() =>{
      try {
        const response = await fetchpendingrequestcount();
       if(response.status==200)
       updateTabBadge("archivedStudyRequest",response.data.data.count);
       updateTabBadge("pending",response.data.data.count);
       updateTabBadge("approved",response.data.data.count);
       updateTabBadge("rejected",response.data.data.count);

      } catch (error) {
        console.error("Error fetching archived study request status count:", error);
      }
    };
     
    const updateTabBadge = (tabKey, value) => {
      setTabBadgeState(prev => ({
        ...prev,
        [tabKey]: {
          ...prev[tabKey],
          showBadge: true,
          value,
        },
      }));
    };
    


    const fetchFilterValues = async()=>{
         setStudyListLoading(true);
         studyListRef?.current?.continuousStart();
        try{
          setShowShimmer(true);
          setFilterValueFetchStarted(true);
          let response = null
          if(contextSwitchUser && patientId != undefined && patientId != null){
            response = await getStudyListWithContextSwitch (clientId, secretKey, patientId);
          }else{
            response = await getStudyList();
          }
        if (response.status === 200 && response.data.result === "SUCCESS") {
          
          if(contextSwitchUser && patientId != undefined && patientId != null){
            setSearchDto({...searchDto, patientNameOrId:patientId })
            let newRes = JSON.parse(JSON.stringify(response.data));
            response.data["data"] = newRes.data.studyListResponseDto;
            // await loadByUsername();
          }
            
            setShowShimmer(false);
            // studyListRef?.current?.complete();
            ref?.current?.complete();
            setLoaderRunning(false);
            if (response.data?.data?.showNotificationMessage && localStorage.getItem("showMaintenance") != "false") {
              const obj = {
                show: true,
                message: response.data?.data?.notificationMessage
              };
              setMaintenance(obj);
              localStorage.setItem("showMaintenance", true);
            }
            setStudyListReloadCounter(prev=>prev+1);
            setFullClientFirmList(response.data?.data?.fullClientFirmList);
            setClientFirmList(response.data?.data?.clientFirmList);
            setMinimalClientFirmList(response.data?.data?.minimalClientFirmList);
            if((roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR) && !contextSwitchUser){
              response.data.data.clientFirmList.unshift({id:-1,name:"My Studies"});
              response.data.data.clientFirmList.unshift({id:-2,name:"All"});    
            }else if(roles[0] != USERTYPES.TYPIST && !contextSwitchUser){
              response.data.data.clientFirmList.unshift({id:-2,name:"All"});
            }
            if(!contextSwitchUser && roles.length > 0 && (roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN || roles[0] === USERTYPES.FIRMTECHNICIAN || roles[0] === USERTYPES.FIRMDOCTOR)){
                response.data.data.radiologistList = [...response.data.data.providerFirmList, ...response.data.data.radiologistList];
            }
            if(roles[0] !== USERTYPES.RADIOLOGIST && response?.data?.data?.showAllStudies != null){
              response.data.data.showAllStudies = true;
            }
            if(roles[0] == USERTYPES.TYPIST &&  response?.data?.data?.showAllStudies != null){
              response.data.data.showAllStudies = false;
            }
            setShowClientName(response?.data?.data?.showClientName);
            setShowReferringPhysician(response?.data?.data?.showReferringPhysician);
            setFilterInputValues(response.data.data);
            setStoreFilterInputValues(response.data.data);
            setStudyListSearchDateFilterValue(response?.data?.data?.user?.studylistSearchDateFilter);
            setStudylistOrderBy(response?.data?.data?.user?.studylistOrderBy != null ? Number(response.data.data.user.studylistOrderBy) : 1);
            const userNoOfImagesFilter = response?.data?.data?.user?.noOfImagesFilter;
            if (userNoOfImagesFilter !== undefined && userNoOfImagesFilter !== null) {
              setPreferenceNoOfImagesFilter(userNoOfImagesFilter);
              setNoOfImagesfilter(userNoOfImagesFilter);
              setSearchDto(prev => ({ ...prev, noOfImages: userNoOfImagesFilter }));
            } else {
              setPreferenceNoOfImagesFilter(null);
              setNoOfImagesfilter(null);
              setSearchDto(prev => ({ ...prev, noOfImages: null }));
            }
            setShowLightTheme(response?.data?.data?.lightThemeUser);
            sessionStorage.setItem('isLightThemeUser',response?.data?.data?.lightThemeUser);
            setCustomDateFilter(response?.data?.data?.customDateFilter);
            setMaxBulkReportDownload(response?.data?.data?.maxBulkReportDownload);
        }else{
          setLoaderRunning(false);
          ref?.current?.complete();
          setShowShimmer(false);
          setShowModal(()=>{
            const newItem = {...showModal};
            newItem.appFailer = true;
            newItem.description = t("string-literals.error-msg");
            return newItem;
          });    
        }
        }catch(e){
          setLoaderRunning(false);
          ref?.current?.complete();
          setShowShimmer(false);
          setShowModal(()=>{
            const newItem = {...showModal};
            newItem.appFailer = true;
            newItem.description = t("string-literals.error-msg");
            return newItem;
          });    
        }
    }


    useEffect(() => {
      const isBlitzSession = window.location.pathname === AuthRoutes.BLITZREPORTING;
        if(roles.length > 0 && filterValueFetchStarted == null && !isBlitzSession){
          setLoaderRunning(true);
          ref?.current?.continuousStart();
          setShowShimmer(true);          
          fetchFilterValues();
          returnedStudyCountApiFunc();
        }
        
      }, [roles]);

    useEffect(()=>{
      if(contextSwitchUser){
        setLoaderRunning(true);
          ref?.current?.continuousStart();
          setShowShimmer(true);          
          fetchFilterValues();
      }
    },[contextSwitchUser])
    
    useEffect(()=>{
        setTrackApplyButton(false);
    },[searchDto])


    useEffect(() => {
        if (!authenticated) {
          loadByUsername();
        }
      }, []);

    const updateSelectedStudies = (studyIds) =>{
        setSelectedStudies(studyIds);
    }

    const columns = useMemo(() => StudyListColumns(studyData), [studyData]);

    const setHospital = (hospital) => {
        if(searchDto.hospital === undefined) {
            setSearchDto({...searchDto, hospital: [hospital]});
        } else if(searchDto.hospital.includes(hospital)) {
            setSearchDto({...searchDto, hospital: searchDto.hospital.filter((c) => c != hospital)})
        } else {
            setSearchDto({...searchDto, hospital: [...searchDto.hospital, hospital]})
        }
        // console.log(searchDto)
    }

    const setModality = (modality) => {
        if(searchDto.modality === undefined) {
            setSearchDto({...searchDto, modality: [modality]});
        } else if(searchDto.modality.includes(modality)) {
            setSearchDto({...searchDto, modality: searchDto.modality.filter((c) => c != modality)})
        } else {
            setSearchDto({...searchDto, modality: [...searchDto.modality, modality]})
        }
        // console.log(searchDto)
    }

    const setModalityIds = (modality,id,checkStatus) => {
        // console.log("----- Modality -----");
        // console.log(modality+" "+id+" "+checkStatus);
        if(checkStatus == true){
            setFilterBadges([...filterBadges, {key:"modalityIds",label:modality,value:id}]);
        }else{
            setFilterBadges((current) =>
                    current.filter((item) => item.label !== modality)
        );
        }
        
        if(searchDto.modalityIds === undefined || searchDto.modalityIds == null) {
            setSearchDto({...searchDto, modalityIds: [id]});
        } else if(searchDto.modalityIds?.includes(id)) {
            setSearchDto({...searchDto, modalityIds: searchDto.modalityIds.filter((c) => c != id)})
        } else {
            setSearchDto({...searchDto, modalityIds: [...searchDto.modalityIds, id]})
        }
        // console.log(searchDto)
    }

    const setSubModalityIds = (serviceName, id, checkStatus) => {
    if(checkStatus == true){
        setFilterBadges([...filterBadges, {key:"subModalityIds", label:serviceName, value:id}]);
    }else{
        setFilterBadges((current) =>
            current.filter((item) => item.label !== serviceName)
        );
    }
    if(searchDto.subModalityIds === undefined || searchDto.subModalityIds == null) {
        setSearchDto({...searchDto, subModalityIds: [id]});
    } else if(searchDto.subModalityIds?.includes(id)) {
        setSearchDto({...searchDto, subModalityIds: searchDto.subModalityIds.filter((c) => c != id)})
    } else {
        setSearchDto({...searchDto, subModalityIds: [...searchDto.subModalityIds, id]})
    }
}

    const setClassificationIds = (classification,id,checkStatus) => {
      // console.log("----- Modality -----");
      // console.log(modality+" "+id+" "+checkStatus);
      if(checkStatus == true){
          setFilterBadges([...filterBadges, {key:"modalityIds",label:classification,value:id}]);
      }else{
          setFilterBadges((current) =>
                  current.filter((item) => item.label !== classification)
      );
      }
      
      if(searchDto.classificationIds === undefined || searchDto.classificationIds == null) {
          setSearchDto({...searchDto, classificationIds: [id]});
      } else if(searchDto.classificationIds?.includes(id)) {
          setSearchDto({...searchDto, classificationIds: searchDto.classificationIds.filter((c) => c != id)})
      } else {
          setSearchDto({...searchDto, classificationIds: [...searchDto.classificationIds, id]})
      }
      // console.log(searchDto)
    }

    const setClientOrFirmIds = (clientName, id, checkStatus) => {
      const clientListForAllIds = storefilterInputValues?.clientFirmList || filterInputValues?.clientFirmList || [];
      const allClientIds = clientListForAllIds
        .filter(item => item.id > 0)
        .map(item => item.id);

      const allSelectableIds = [-1, ...allClientIds];

      let currentIds = searchDto.clientOrFirmIds || [];

      let updatedIds = currentIds;

      if (id === -2) { //All option selected
        updatedIds = checkStatus ? [-2, ...allSelectableIds] : [];
      } else if (id === -1) { //My Studies option selected
        updatedIds = checkStatus
          ? [...currentIds, -1]
          : currentIds.filter(v => v !== -1);

        updatedIds = updatedIds.filter(v => v !== -2);

        if (allSelectableIds.every(v => updatedIds.includes(v))) {
          updatedIds = [-2, ...updatedIds];
        }
      } else { // Individual client/firm option selected
        updatedIds = checkStatus
          ? [...currentIds, id]
          : currentIds.filter(v => v !== id);

        updatedIds = updatedIds.filter(v => v !== -2);

        if (allSelectableIds.every(v => updatedIds.includes(v))) {
          updatedIds = [-2, ...updatedIds];
        }
      }

      const clientBadges = buildClientBadges(updatedIds);
      const nonClientBadges = filterBadges.filter(
        badge => badge.key !== "clientOrFirmIds"
      );

      setFilterBadges([...nonClientBadges, ...clientBadges]);

      setSearchDto({
        ...searchDto,
        clientOrFirmIds: updatedIds
      });
    };

    const buildClientBadges = (ids) => {
      const clientListForBadges = storefilterInputValues?.clientFirmList || filterInputValues?.clientFirmList || [];
      return clientListForBadges
        .filter(item => ids.includes(item.id) && item.id !== -2)
        .map(item => ({
          key: "clientOrFirmIds",
          label: item.name,
          value: item.id
        }));
    };


    const setProviderIds = (provider,id,checkStatus) => {
        let idStatus = (provider.firstName == null || provider.firstName == undefined) ? "F":"R";
        let isFirm = (provider.firstName == null || provider.firstName == undefined) ? true: false;
        if(checkStatus == true){
            setFilterBadges([...filterBadges, 
                {key:"providerIds",label:getRadiologistDisplayName(provider),value:idStatus+id}]);
        }else{
            setFilterBadges((current) =>
                    current.filter((item) => item.value !== idStatus+id)
        );
        }
        
        if(searchDto.providerIds === undefined || searchDto.providerIds == null) {
            setSearchDto({...searchDto, providerIds: [idStatus+id]});
        } else if(searchDto.providerIds?.includes(idStatus+id)) {
            setSearchDto({...searchDto, providerIds: searchDto.providerIds.filter((c) => c != idStatus+id)})
        } else {
            setSearchDto({...searchDto, providerIds: [...searchDto.providerIds, idStatus+id]});
        }
    }

    

    const setUploadDate = (data) => {
      setFilterBadges((prevBadges) => {
        const currentIndex = prevBadges.findIndex((ele) => ele.key === "uploadDate");
        const updatedBadge = { key: "uploadDate", label: data.text, value: data.key };
        if (currentIndex === -1) {
          return [...prevBadges, updatedBadge];
        }
        const newValue = [...prevBadges];
        newValue[currentIndex] = { ...newValue[currentIndex], ...updatedBadge };
        return newValue;
      });

      setSearchDto((prevSearchDto) => ({ ...prevSearchDto, uploadDate: data.key }));
    }

    const setPathology = (data) => {
        if(searchDto.annotationId != null && searchDto.annotationId != ""){
            const currentIndex = filterBadges.findIndex((ele) => ele.key === "annotationId");
            const updatedValue = {...filterBadges[currentIndex],  label:data.name,value:data.name};
            const newValue = [...filterBadges];
            newValue[currentIndex] = updatedValue;
            setFilterBadges(newValue);
        }else{
            setFilterBadges([...filterBadges, {key:"annotationId",label:data.name,value:data.name}]);
        }
        
        setSearchDto({...searchDto, annotationId:data.name })
    }

    const setPriority = (data) => {
        if(searchDto.aiPredictionId != null && searchDto.aiPredictionId != ""){
            const currentIndex = filterBadges.findIndex((ele) => ele.key === "aiPredictionId");
            const updatedValue = {...filterBadges[currentIndex],  label:data.key,value:data.text};
            const newValue = [...filterBadges];
            newValue[currentIndex] = updatedValue;
            setFilterBadges(newValue);
        }else{
            setFilterBadges([...filterBadges, {key:"aiPredictionId",label:data.key,value:data.text}]);
        }
        
        setSearchDto({...searchDto, aiPredictionId:data.text })
    }

    const setStudyDate = (date,type) => {
       date = Moment(date);
        const formattedDate = date.format('DD-MMM-YYYY');
        if(type){
            if(searchDto.studyDateFrom != null && searchDto.studyDateFrom != ""){
                const currentIndex = filterBadges.findIndex((ele) => ele.key === "studyDateFrom");
                const updatedValue = {...filterBadges[currentIndex],  label:"Study Date From: "+formattedDate,value:formattedDate};
                const newValue = [...filterBadges];
                newValue[currentIndex] = updatedValue;
                setFilterBadges(newValue);
            }else{
                    const currentIndex = filterBadges.findIndex((ele) => ele.key === "studyDateFrom");
                    if(currentIndex !== -1){
                      const updatedValue = {...filterBadges[currentIndex],  label:"Study Date From: "+formattedDate,value:formattedDate};
                      const newValue = [...filterBadges];
                      newValue[currentIndex] = updatedValue;
                      setFilterBadges(newValue);
                    }else{
                      setFilterBadges([...filterBadges, {key:"studyDateFrom",label:"Study Date From: "+formattedDate,value:formattedDate}]);
                    }
                }
            setSearchDto({...searchDto, studyDateFrom:formattedDate })
        }else{
            if(searchDto.studyDateTo != null && searchDto.studyDateTo != ""){
                const currentIndex = filterBadges.findIndex((ele) => ele.key === "studyDateTo");
                const updatedValue = {...filterBadges[currentIndex],  label:"Study Date To: "+formattedDate,value:formattedDate};
                const newValue = [...filterBadges];
                newValue[currentIndex] = updatedValue;
                setFilterBadges(newValue);
            }else{
                    setFilterBadges([...filterBadges, {key:"studyDateTo",label:"Study Date To: "+formattedDate,value:formattedDate}]);
                }
            setSearchDto({...searchDto, studyDateTo:formattedDate })
        }   
    }

    const setReportDate = (date,type) => {
      date = Moment(date);
       const formattedDate = date.format('DD-MMM-YYYY');
       if(type){
            if(searchDto.reportDateFrom != null && searchDto.reportDateFrom != ""){
                const currentIndex = filterBadges.findIndex((ele) => ele.key === "reportDateFrom");
                const updatedValue = {...filterBadges[currentIndex],  label:"Report Date From: "+formattedDate,value:formattedDate};
                const newValue = [...filterBadges];
                newValue[currentIndex] = updatedValue;
                setFilterBadges(newValue);
            }else{
                    const currentIndex = filterBadges.findIndex((ele) => ele.key === "reportDateFrom");
                    if(currentIndex !== -1){
                      const updatedValue = {...filterBadges[currentIndex],  label:"Report Date From: "+formattedDate,value:formattedDate};
                      const newValue = [...filterBadges];
                      newValue[currentIndex] = updatedValue;
                      setFilterBadges(newValue);
                    }else{
                       setFilterBadges([...filterBadges, {key:"reportDateFrom",label:"Report Date From: "+formattedDate,value:formattedDate}]);
                    }
                }
            setSearchDto({...searchDto, reportDateFrom:formattedDate })
        }else{
            if(searchDto.reportDateTo != null && searchDto.reportDateTo != ""){
                const currentIndex = filterBadges.findIndex((ele) => ele.key === "reportDateTo");
                const updatedValue = {...filterBadges[currentIndex],  label:"Report Date To: "+formattedDate,value:formattedDate};
                const newValue = [...filterBadges];
                newValue[currentIndex] = updatedValue;
                setFilterBadges(newValue);
            }else{
                     setFilterBadges([...filterBadges, {key:"reportDateTo",label:"Report Date To: "+formattedDate,value:formattedDate}]);
                }
            setSearchDto({...searchDto, reportDateTo:formattedDate })
       }   
   }

    const setPatientDetail = (data) => {
        setSearchDto({...searchDto, patientNameOrId:data })
    }

    const setOrderId = (data) => {
      setSearchDto({...searchDto, orderId:data })
    }

    const setAccessionNumber = (data) => {
      setSearchDto({...searchDto, accessionNumber:data })
    }

    const setKeyword = (data) => {
      setSearchDto({...searchDto, keyword:data })
    }

    const setStudyDescription = (data) => {
      setSearchDto({...searchDto, studyDescription:data })
    }

    useEffect(()=>{
       if(searchDto.modalityIds != null){
        setApplyClick(true);
       }
    },[searchDto.modalityIds]);



    const removeBadgeFromFilter = (toBeRemoveObj) => {
      setFilterBadges((current) =>
        current.filter((item) =>
          toBeRemoveObj.label ? item.label !== toBeRemoveObj.label : item.key !== toBeRemoveObj.key
        )
      );
      setStoreFilterBadges((current) =>
        current.filter((item) =>
          toBeRemoveObj.label ? item.label !== toBeRemoveObj.label : item.key !== toBeRemoveObj.key
        )
      );
    
      // Group the cases where you update searchDto
      setSearchDto((prevState) => {
        let updatedSearchDto = { ...prevState };
    
        if (toBeRemoveObj.key === "modalityIds") {
          updatedSearchDto.modalityIds = updatedSearchDto.modalityIds.filter(
            (c) => c !== toBeRemoveObj.value
          );
        } 
        else if (toBeRemoveObj.key === "subModalityIds") {
          updatedSearchDto.subModalityIds = updatedSearchDto.subModalityIds.filter(
            (c) => c !== toBeRemoveObj.value
          );
        }
        else if (toBeRemoveObj.key === "clientOrFirmIds") {
          updatedSearchDto.clientOrFirmIds = updatedSearchDto.clientOrFirmIds.filter(
            (c) => c !== toBeRemoveObj.value && c !== -2
          );
        } else if (toBeRemoveObj.key === "uploadDate") {
          updatedSearchDto.uploadDate = null;
        } else if (toBeRemoveObj.key === "annotationId") {
          updatedSearchDto.annotationId = null;
        } else if (toBeRemoveObj.key === "aiPredictionId") {
          updatedSearchDto.aiPredictionId = null;
        } else if (toBeRemoveObj.key === "providerIds") {
          updatedSearchDto.providerIds = updatedSearchDto.providerIds.filter(
            (c) => c !== toBeRemoveObj.value
          );
        } else if (toBeRemoveObj.key === "studyDateFrom") {
          updatedSearchDto.studyDateFrom = null;
        } else if (toBeRemoveObj.key === "studyDateTo") {
          updatedSearchDto.studyDateTo = null;
        } else if (toBeRemoveObj.key === "patientName") {
          updatedSearchDto.patientNameOrId = null;
          setPatientNameBadgeShow(false);
        } else if (toBeRemoveObj.key === "keyword") {
          updatedSearchDto.keyword = null;
        } else if (toBeRemoveObj.key === "orderId") {
          updatedSearchDto.orderId = null;
        } else if (toBeRemoveObj.key === "accessionNumber") {
          updatedSearchDto.accessionNumber = null;
        } else if (toBeRemoveObj.key === "studyDescription") {
          updatedSearchDto.studyDescription = null;
        } else if (toBeRemoveObj.key === "reportDateFrom") {
          updatedSearchDto.reportDateFrom = null;
        } else if (toBeRemoveObj.key === "reportDateTo") {
          updatedSearchDto.reportDateTo = null;
        }
        else if (toBeRemoveObj.key === "noOfImages") {
          updatedSearchDto.noOfImages = null;
        }
        else if (toBeRemoveObj.key === "historyChecks") {
          updatedSearchDto.historyChecks = null;
        }
    
        // Return updated searchDto after modification
        return updatedSearchDto;
      });
    
      // Reset search result length and filter applied after the state updates
      setSearchResultLength(1);
      if (toBeRemoveObj.key === "studyDateFrom") {
        setStudyDateFrom(isMobile ? null : new Date());
      }
      if (toBeRemoveObj.key === "studyDateTo") {
        setStudyDateTo(isMobile ? null : new Date());
      }
      if (toBeRemoveObj.key === "reportDateFrom") {
        setReportDateFrom(isMobile ? null : new Date());
      }
      if (toBeRemoveObj.key === "reportDateTo") {
        setReportDateTo(isMobile ? null : new Date());
      }
      let filterUpdated = filterApplied + 1;
      setFilterApplied(filterUpdated);
    };
    

      const hideModal = () => {
        setShowCommunicationModal({studyId:null,show:false,child:false});
        setShowReturnedStudyReasonModal({studyId:null,show:false});
      }

      const returnedStudyCountApiFunc = (studiesData) => {
      const rows = studiesData?.rows || dataQueryState?.data?.rows;
      if (rows) {
        const reasonCounts = rows
            .filter(study => study.unassignedReasonCount > 0)
            .map(study => ({
                studyId: study.id,
                noOfReasons: study.unassignedReasonCount
            }));
        setReturnedReasonCount(reasonCounts);
        }
      }

      const handleEnterKeyPress = (event) => {
        if (event.key === "Enter") {
            handleChangeSizeIndex(0,50,"");
            if(searchDto.orderId != null && searchDto.orderId.length > 0){
              let searchTrimmedData = searchDto.orderId.trim();
              setSearchDto({...searchDto, orderId:searchTrimmedData })
              setSearchDto({...searchDto, patientNameOrId:null })
              setSearchDto({...searchDto, accessionNumber:null })
            }
            if(searchDto.patientNameOrId != null && searchDto.patientNameOrId.length > 0){
              let searchTrimmedData = searchDto.patientNameOrId.trim();
              setSearchDto({...searchDto, patientNameOrId:searchTrimmedData })
              setSearchDto({...searchDto, orderId:null })
              setSearchDto({...searchDto, accessionNumber:null })
            }
            if(searchDto.accessionNumber != null && searchDto.accessionNumber.length > 0){
              let searchTrimmedData = searchDto.accessionNumber.trim();
              setSearchDto({...searchDto, accessionNumber:searchTrimmedData })
              setSearchDto({...searchDto, patientNameOrId:null })
              setSearchDto({...searchDto, orderId:null })
            }
            if(searchDto.keyword != null && searchDto.keyword.length > 0){
              let searchTrimmedData = searchDto.keyword.trim();
              setSearchDto({...searchDto, keyword:searchTrimmedData })
              setSearchDto({...searchDto, accessionNumber:searchTrimmedData })
              setSearchDto({...searchDto, patientNameOrId:null })
              setSearchDto({...searchDto, orderId:null })
            }
            if(searchDto.studyDescription != null && searchDto.studyDescription.length > 0){
              let searchTrimmedData = searchDto.studyDescription.trim();
              setSearchDto({...searchDto, studyDescription:searchTrimmedData })
              setSearchDto({...searchDto, patientNameOrId:null })
              setSearchDto({...searchDto, orderId:null })
              setSearchDto({...searchDto, accessionNumber:null })
              setSearchDto({...searchDto, keyword:null })
            }
            setPatientNameBadgeShow(true);
            let filterUpdated = filterApplied + 1;
            setFilterApplied(filterUpdated);
            // setTimeout(() => {
            //   dataQueryState.refetch();
            // }, 500);
        }
      };

      const handleGenericConfirmModal = () => {
        setShowConfirmModalState(false);
        setShowGenericConfirmModal(false);
      };

      const handleCloseDeleteModal = () => {
        if(showImageDeleteModal){
          setShowImageDeleteModal(false);
        }
        if (showDeleteModal) {
          setShowDeleteModal(false);
        }
        if (showDeleteSuccessModal) {
          setShowDeleteSuccessModal(false);
        }
        setShowConfirmModalState(false);
      };

      const handleCloseReInferenceModal = () => {
        setShowReInferenceModal(false);
        setShowConfirmModalState(false);
      };

      const handleBatchDelete = () => {
        
        if(batchReinferenceAndDeleteArray.batchDelete != null && batchReinferenceAndDeleteArray.batchDelete.length > 0){
            setConfirmMessage(t("confirm-message.delete-batch-confirm-message"));
            setShowConfirmModalState(true);
            setShowDeleteModal(true);
            setShowImageDeleteModal(false);
            setRunBatchDelete(false);
        }
      };

      const handleBatchImageDelete = () => {
        
        if(batchReinferenceAndDeleteArray.batchImageDelete != null && batchReinferenceAndDeleteArray?.batchImageDelete?.length > 0){
            setConfirmMessage(t("confirm-message.delete-image-batch-confirm-message"));
            setShowConfirmModalState(true);
            setShowDeleteModal(false);
            setShowImageDeleteModal(true);
            setRunBatchDelete(false);
        }
      };

      const getActiveRowIndexForBatch = (obj) => {
        const trueKeys = Object.keys(obj).filter(key => obj[key] === true);
        const trueKeysAsNumbers = trueKeys.map(Number);
        return trueKeysAsNumbers;
      }

      const getCountOfAbleToDeleteStudies = (rowSelectedArray,isBatchDelete) => {
            let countBatchDelete = 0;
            let countBatchInference = 0;
            let batchReinference = [];
            let countBatchImageDelete = 0;
            let batchDelete = [];
            let batchImageDelete =[];
            if(dataQueryState != undefined && dataQueryState.data != undefined){
                for(const key in dataQueryState.data.rows){
                    if(rowSelectedArray.includes(parseInt(key, 10))){
    
                        let study = dataQueryState.data.rows[key];
    
                        if(((study.assignmentList[0].clientId == 0 || (study?.studyFromMinimalFirm && study?.sourceFirmId == study.assignmentList[0].clientId)) && study.reportDoneStatus == 0 && study.assignmentList[0].providerId == null)
                        ||  study.assignmentList[0].firmName == 'firsthospital'
                        ){
                           
                            batchDelete.push(study.id)
                            countBatchDelete++;
                            if(study.clientBillingStudy  && study.noOfImages > 0){
                              countBatchImageDelete++;
                              batchImageDelete.push(study.id);
                            }
                            
                        }
                        if(((REINFERECE_ALLOWED_MODALITY.includes(study.modality.name) && study.triageXRAYStudies) || study.aiReinference) && study.reportDoneStatus != 2 && !study.genkiStudy){
                            batchReinference.push(study.id);
                            countBatchInference++;
                          }
                    }
                }

                setBatchReinferenceAndDeleteArray(()=>{
                    const newItem = {...batchReinferenceAndDeleteArray};
                    newItem.batchInference = batchReinference;
                    newItem.batchInferenceCount = countBatchInference;
                    newItem.batchDelete = batchDelete;
                    newItem.batchDeleteCount = countBatchDelete;
                    newItem.batchDeleteImageCount = countBatchImageDelete;
                    newItem.batchImageDelete = batchImageDelete;
                    return newItem;
                })
            }
            

            //return isBatchDelete ? countBatchDelete : countBatchInference;
      } 

      useEffect(()=>{
        // console.log("---- Row Selected Index obj ----",getActiveRowIndexForBatch(rowSelectionState));
        let selectedArray = getActiveRowIndexForBatch(rowSelectionState);
        if(selectedArray.length > 0){
            getCountOfAbleToDeleteStudies(selectedArray,true);
            setRowSelectedArray(selectedArray);
        }else{
            setRowSelectedArray(selectedArray);
        }
        setResetRowSelection(false);
      },[rowSelectionState])


      const findStudyIdsFromRowSelection = (rowSelection) => {
        let studyData = dataQueryState.data?.rows;
        let tempList = Object.keys(rowSelection).map((item, index) => {
          return studyData[index].id;
        });
        return tempList;
      };

      const handleRowDeleteOrReinferenceUpdate = (inputArray,isBatchDelete) => {
        if(isBatchDelete){
            let newData = dataQueryState?.data?.rows.filter(
                (row) => !inputArray.includes(row.id)
              );
              setDataQueryState(() => {
                const newValue = {
                  ...dataQueryState,
                };
                newValue.data.rows = newData;
                return newValue;
              });
        }else if(!isBatchDelete){

                //(study.aiProcessed == 2 && study.aiEmergencyMax == -1)
      //|| (study.reportDoneStatus != 2 && study.aiProcessed == 2)

                let newData = dataQueryState?.data?.rows?.map((item,idx)=>{
                    if(inputArray.includes(item.id)){
                        item.aiProcessed = 2;
                        item.aiEmergencyMax = -1;
                        item.studyPredictionList = [];
                        item.attention = false;
                        item.emergency = false;
                        item.nonMedicalEmergency = false;
                        item.studyClassificationPredictionList = [];
                        item.vendorPredictionList = [];
                        return item;
                    }
                    return item;
                });
                  setDataQueryState(() => {
                    const newValue = {
                      ...dataQueryState,
                    };
                    newValue.data.rows = newData;
                    return newValue;
                  });
        }
    }

      const deleteStudyFunc = async () => {
        try{

          switch(true){
            case showDeleteModal && !showImageDeleteModal:
            if (batchReinferenceAndDeleteArray.batchDelete != null && batchReinferenceAndDeleteArray.batchDelete.length > 0) {
              setShowDeleteModal(false);
              setShowConfirmModalState(false);
              setLoaderRunning(true);
              ref.current.continuousStart();
              const response = await batchDeleteStudyApi(batchReinferenceAndDeleteArray.batchDelete,false);
              if(response.data.result == "SUCCESS"){
                  setShowShimmer(false);
                  setLoaderRunning(false);
                  ref.current.complete();
                  setAlertSuccessModalStudyListState(()=>{
                      const newItem = {...alertSuccessStudyListState};
                      newItem.show = true;
                      newItem.heading = "Alert";
                      newItem.isError = false;
                      newItem.isSuccess = false;
                      newItem.isWarning = true;
                      newItem.description = response.data.message;
                      return newItem;
                    });
                  //setDeleteSuccessMessage(response.data.message);
                  //setShowDeleteSuccessModal(true);
                  //setShowConfirmModalState(true);
                  setResetRowSelection(true);
                  handleRowDeleteOrReinferenceUpdate(batchReinferenceAndDeleteArray.batchDelete,true);
              }else{
                  setShowShimmer(false);
                  setLoaderRunning(false);
                  ref.current.complete();
                  setAlertSuccessModalStudyListState(()=>{
                      const newItem = {...alertSuccessStudyListState};
                      newItem.show = true;
                      newItem.heading = "Alert";
                      newItem.isError = false;
                      newItem.isSuccess = false;
                      newItem.isWarning = true;
                      newItem.description = t("string-literals.failed-message");
                      return newItem;
                    });
                  //setDeleteSuccessMessage(response.data.message);
                  //setShowDeleteSuccessModal(true);
                  //setShowConfirmModalState(true);
              }
             
            }
            break;
            case !showDeleteModal && showImageDeleteModal:
              if (batchReinferenceAndDeleteArray.batchImageDelete != null && batchReinferenceAndDeleteArray.batchImageDelete.length > 0) {
                setShowImageDeleteModal(false);
                setShowConfirmModalState(false);
                setLoaderRunning(true);
                ref.current.continuousStart();
                const response = await batchDeleteStudyApi(batchReinferenceAndDeleteArray.batchImageDelete, true);
                if(response.data.result == "SUCCESS"){
                    setShowShimmer(false);
                    setLoaderRunning(false);
                    ref.current.complete();
                    setResetRowSelection(true);
                    setRefreshRequired(()=>{
                      const newItem = {...refreshRequired};
                      newItem[TAB_NAME.UNREPORTED].alreadyLoaded = false;
                      newItem[TAB_NAME.CLOSED].alreadyLoaded = false;
                      return newItem;
                    });
  
                    setAlertSuccessModalStudyListState(()=>{
                        const newItem = {...alertSuccessStudyListState};
                        newItem.show = true;
                        newItem.heading = "Alert";
                        newItem.isError = false;
                        newItem.isSuccess = false;
                        newItem.isWarning = true;
                        newItem.description = response.data.message;
                        return newItem;
                      });
                    //setDeleteSuccessMessage(response.data.message);
                    //setShowDeleteSuccessModal(true);
                    //setShowConfirmModalState(true);
                }else{
                    setShowShimmer(false);
                    setLoaderRunning(false);
                    ref.current.complete();
                    setAlertSuccessModalStudyListState(()=>{
                        const newItem = {...alertSuccessStudyListState};
                        newItem.show = true;
                        newItem.heading = "Alert";
                        newItem.isError = false;
                        newItem.isSuccess = false;
                        newItem.isWarning = true;
                        newItem.description = t("string-literals.failed-message");
                        return newItem;
                      });
                    //setDeleteSuccessMessage(response.data.message);
                    //setShowDeleteSuccessModal(true);
                    //setShowConfirmModalState(true);
                }
               
              }
              break;
          }
        }catch(e){
          setShowShimmer(false);
          setLoaderRunning(false);
          ref.current.complete();
          setAlertSuccessModalStudyListState(()=>{
              const newItem = {...alertSuccessStudyListState};
              newItem.show = true;
              newItem.heading = "Alert";
              newItem.isError = false;
              newItem.isSuccess = false;
              newItem.isWarning = true;
              newItem.description = t("string-literals.failed-message");
              return newItem;
            });
        }
        

        
      };

      const handleBatchReInference = async () => {
        if (batchReinferenceAndDeleteArray.batchInference != null && batchReinferenceAndDeleteArray.batchInference.length > 0) {
            setLoaderRunning(true);
            ref.current.continuousStart();
        //   let payload = findStudyIdsFromRowSelection(rowSelectionState);
          const response = await batchReinferenceStudyApi(batchReinferenceAndDeleteArray.batchInference);
          if(response.data.result == "SUCCESS"){
            setLoaderRunning(false);
            ref.current.complete();
            setResetRowSelection(true);
            setAlertSuccessModalStudyListState(()=>{
                const newItem = {...alertSuccessStudyListState};
                newItem.show = true;
                newItem.heading = "Alert";
                newItem.isError = false;
                newItem.isSuccess = false;
                newItem.isWarning = true;
                newItem.description = t("confirm-message.reInference-message-studies");
                return newItem;
              });
            handleRowDeleteOrReinferenceUpdate(batchReinferenceAndDeleteArray.batchInference,false);
          }else{
            setLoaderRunning(false);
            ref.current.complete();
            setAlertSuccessModalStudyListState(()=>{
                const newItem = {...alertSuccessStudyListState};
                newItem.show = true;
                newItem.heading = "Alert";
                newItem.isError = false;
                newItem.isSuccess = false;
                newItem.isWarning = true;
                newItem.description = t("string-literals.failed-message");
                return newItem;
              });
          }
          
        } else {
          setConfirmMessage(t("confirm-message.no-study-selected"));
          setShowGenericConfirmModal(true);
        }
      };

  const handleBatchReportDownload = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();

    const selectedRows = Object.keys(rowSelectionState)
      .map(key => dataQueryState.data.rows[Number(key)])
      .filter(Boolean);

    const allStudyIds = selectedRows.map(row => row.id);
   
    const requestBody = {
      studyIds: allStudyIds,
      xrayReportType: xrayReportType,
      otherReportType: nonXrayReportType
    };

    const response = await initiateBulkDownload(requestBody);
    if (response.data.status == "SUCCESS") {
      setLoaderRunning(false);
      ref.current.complete();
      setResetRowSelection(true);
      setAlertSuccessModalStudyListState(() => {
        const newItem = { ...alertSuccessStudyListState };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = t("confirm-message.batch-report-download-success");
        return newItem;
      });
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      setAlertSuccessModalStudyListState(() => {
        const newItem = { ...alertSuccessStudyListState };
        newItem.show = true;
        newItem.heading = "Alert";
        newItem.isError = false;
        newItem.isSuccess = false;
        newItem.isWarning = true;
        newItem.description = response.data.message || t("string-literals.failed-message");
        return newItem;
      });
    }
    setXrayReportType("pdf");
    setNonXrayReportType("pdf");
  };

      useEffect(()=>{
            if(runBatchDelete){
                handleBatchDelete()
            }
      },[runBatchDelete])

      const menuItemsForBatchAndInference = (rowSelection) => {

        let items = [
          {
            key: "Batch Delete",
            iconProps: { iconName: "delete" },
            text: "Batch Delete",
            onClick: () => setRunBatchDelete(true),
          },
          {
            key: "Batch Reinference",
            iconProps: { iconName: "refresh" },
            text: "Batch Reinference",
            onClick: () => handleBatchReInference(),
          },
        ];
        return items;
     }

     const handleSavedTabChange = (keyToUpdate, tabTitle, selected_value) => {
            let oldUnreportedTabObj = savedAllTabs;
            oldUnreportedTabObj.data.id = keyToUpdate;
            oldUnreportedTabObj.data.title = tabTitle;
            oldUnreportedTabObj.data.tabId = selected_value;
            // setSelectedValue("study_1");
            setSelectedValue(selected_value);
           // handleCXRBorderChange("study_1",tabDetails(roles,"study_1",themeName, oldUnreportedTabObj),themeName)
                setSavedAllTabs(()=>{
                    const newItem = {...savedAllTabs};
                    newItem.data = oldUnreportedTabObj.data;
                    return newItem;
                });
            
      }

      const menuSavedTabs = {
        shouldFocusOnMount: true,
        items: [
            {
            key: 'saved',
            className: 'menuPropListItem',
            // iconProps: { iconName: 'delete' },
            style: {backgroundColor:savedAllTabs.data.id == "saved"?'#80808085':'unset'},
            text: 'All',
            title: 'All',
            onClick: () => {
                handleSavedTabChange("saved",SAVED_TABS.allStudies)
            }
           },
          {
            key: 'reviedPending',
            // iconProps: { iconName: 'delete' },
            className: 'menuPropListItem',
            style: {backgroundColor:savedAllTabs.data.id == "reviewPending"?'#80808085':'unset'},
            text: 'Review Pending',
            title: 'Review Pending',
           onClick: () => {
                handleSavedTabChange("reviewPending",SAVED_TABS.reviewPending)
           }
          }
        ]
      };
    
      const handleCXRTabChange = (keyToUpdate,tabTitle, selected_value) => {
            let oldUnreportedTabObj = unreportedAllTabs;
            oldUnreportedTabObj.data.id = keyToUpdate;
            oldUnreportedTabObj.data.title = tabTitle;
            oldUnreportedTabObj.data.tabId = selected_value;
            // setSelectedValue("study_1");
            setSelectedValue(selected_value);
           // handleCXRBorderChange("study_1",tabDetails(roles,"study_1",themeName, oldUnreportedTabObj),themeName)
                setUnreportedAllTabs(()=>{
                    const newItem = {...unreportedAllTabs};
                    newItem.data = oldUnreportedTabObj.data;
                    return newItem;
                });
            
      }

      // cxr changes
      const menuCXRtabs = {
        shouldFocusOnMount: true,
        items: [
            {
            key: 'all',
            className: 'menuPropListItem',
            // iconProps: { iconName: 'delete' },
            style: {backgroundColor:unreportedAllTabs.data.id == "unreported"?'#80808085':'unset'},
            text: 'All',
            title: 'All',
            onClick: () => {
                handleCXRTabChange("unreported",CXR_TABS.unreported)
            }
           },
          {
            key: 'normal',
            // iconProps: { iconName: 'delete' },
            className: 'menuPropListItem',
            style: {backgroundColor:unreportedAllTabs.data.id == "normal"?'#80808085':'unset'},
            text: 'CXR: No Suspicions',
            title: 'CXR: No Suspicions',
           onClick: () => {
                handleCXRTabChange("normal",CXR_TABS.normal)
           }
          },
          {
            key: 'normalwithfb',
            className: 'menuPropListItem',
            // iconProps: { iconName: 'delete' },
            style: {backgroundColor:unreportedAllTabs.data.id == "normalwithfb"?'#80808085':'unset'},
            text: 'CXR: FO Only',
            title: 'CXR: FO Only',
           onClick: () => {
                handleCXRTabChange("normalwithfb",CXR_TABS.normalWithFB)
           }
          },
          {
            key: 'abnormal',
            className: 'menuPropListItem',
            // iconProps: { iconName: 'delete' },
            style: {backgroundColor:unreportedAllTabs.data.id == "abnormal"?'#80808085':'unset'},
            text: 'CXR: With Suspicions',
            title: 'CXR: Fo Suspicions',
           onClick: () => {
                handleCXRTabChange("abnormal",CXR_TABS.abnormal)
           }
          }
        ]
      };

      const handlePeerReviewTabChange = (keyToUpdate,tabTitle, selected_value) => {
        let oldUnreportedTabObj = peerReviewAssignedTab;
        oldUnreportedTabObj.data.id = keyToUpdate;
        oldUnreportedTabObj.data.title = tabTitle;
        oldUnreportedTabObj.data.tabId = selected_value;
        // setSelectedValue("study_1");
        setSelectedValue(selected_value);
        // handleCXRBorderChange("study_1",tabDetails(roles,"study_1",themeName, oldUnreportedTabObj),themeName)
        setPeerReviewAssignedTab(() => {
          const newItem = { ...peerReviewAssignedTab };
          newItem.data = oldUnreportedTabObj.data;
          return newItem;
        });


        const columnMap = {
          [TAB_NAME.REVIEWASSIGNED]: "review_assigned_date",
          [TAB_NAME.REVIEWCOMPLETE]: "review_completed_date",
          [TAB_NAME.EVALUATIONASSIGNED]: "evaluation_assigned_date",
          [TAB_NAME.EVALUATIONCOMPLETE]: "evaluation_completion_date",
        };

        const excludedColumn = columnMap[keyToUpdate];

        const relevantColumns = new Set(Array.from(DEFAULT_SORT_COLUMNS).filter(col => col !== excludedColumn));

        if (sortGlobal.sortOrder === "desc" && relevantColumns.has(sortGlobal.sortColumn)) {
          const newSortColumn = columnMap[keyToUpdate];
          if (newSortColumn) {
            setSortGlobal((prevSort) => ({
              ...prevSort,
              sortColumn: newSortColumn,
              sortOrder: "desc",
            }));
            return;
          }
        }

        if (["review_assigned_date", "report_submitted_date", "review_completed_date", "evaluation_assigned_date", "evaluation_completion_date"].includes(sortGlobal.sortColumn)) {
          setSortGlobal((prevSort) => ({
            ...prevSort,
            sortColumn: "assignment_created_date",
            sortOrder: "desc",
          }));
        }
  }

      const handleReportedTabChange = (keyToUpdate, tabTitle, selected_value) => {
        let oldReportedTabObj = reportedAllTabs;
        oldReportedTabObj.data.id = keyToUpdate;
        oldReportedTabObj.data.title = tabTitle;
        oldReportedTabObj.data.tabId = selected_value;
        setSelectedValue(selected_value);
        setReportedAllTabs(() => {
          const newItem = { ...reportedAllTabs };
          newItem.data = oldReportedTabObj.data;
          return newItem;
        });
      }

      const handleQCReviewTabChange = (keyToUpdate, tabTitle, selected_value) => {
        let oldQcReviewTabObj = qcReviewAllTabs;
        oldQcReviewTabObj.data.id = keyToUpdate;
        oldQcReviewTabObj.data.title = tabTitle;
        oldQcReviewTabObj.data.tabId = selected_value;
        setSelectedValue(selected_value);
        setQcReviewAllTabs(() => {
          const newItem = { ...qcReviewAllTabs };
          newItem.data = oldQcReviewTabObj.data;
          return newItem;
        });
      }

      const menuPeerReviewtabs = {
        shouldFocusOnMount: true,
        items: [
            {
            key: 'reviewAssigned',
            className: 'menuPropListItem',
            // iconProps: { iconName: 'delete' },
            style: {backgroundColor:peerReviewAssignedTab.data.id == "reviewAssigned"?'#80808085':'unset'},
            text: 'Review Pending',
            title: 'Review Pending',
            onClick: () => {
                handlePeerReviewTabChange("reviewAssigned",PEER_REVIEW_TABS.reviewAssigned)
            }
           },
          {
            key: 'reviewComplete',
            // iconProps: { iconName: 'delete' },
            className: 'menuPropListItem',
            style: {backgroundColor:peerReviewAssignedTab.data.id == "reviewComplete"?'#80808085':'unset'},
            text: 'Review Complete',
            title: 'Review Complete',
           onClick: () => {
                handlePeerReviewTabChange("reviewComplete",PEER_REVIEW_TABS.reviewComplete)
           }
          },
          {
            key: 'evaluationAssigned',
            className: 'menuPropListItem',
            // iconProps: { iconName: 'delete' },
            style: {backgroundColor:peerReviewAssignedTab.data.id == "evaluationAssigned"?'#80808085':'unset'},
            text: 'Evaluation Pending',
            title: 'Evaluation Pending',
           onClick: () => {
                handlePeerReviewTabChange("evaluationAssigned",PEER_REVIEW_TABS.evaluationAssigned)
           }
          },
          {
            key: 'evaluationComplete',
            className: 'menuPropListItem',
            // iconProps: { iconName: 'delete' },
            style: {backgroundColor:peerReviewAssignedTab.data.id == "evaluationComplete"?'#80808085':'unset'},
            text: 'Evaluation Complete',
            title: 'Evaluation Complete',
           onClick: () => {
                handlePeerReviewTabChange("evaluationComplete",PEER_REVIEW_TABS.evaluationComplete)
           }
          }
        ]
      };
	  
	  
	  const handleArchivedStudyRequestTabChange = (keyToUpdate,tabTitle, selected_value) => {
        let oldUnreportedTabObj = archivedStudyRequestTab;
        oldUnreportedTabObj.data.id = keyToUpdate;
        oldUnreportedTabObj.data.title = tabTitle;
        oldUnreportedTabObj.data.tabId = selected_value;
        // setSelectedValue("study_1");
        setSelectedValue(selected_value);
        // handleCXRBorderChange("study_1",tabDetails(roles,"study_1",themeName, oldUnreportedTabObj),themeName)
        setArchivedStudyRequestTab(() => {
          const newItem = { ...archivedStudyRequestTab };
          newItem.data = oldUnreportedTabObj.data;
          return newItem;
        });


        const columnMap = {
          [TAB_NAME.PENDING]: "requested_date",
          [TAB_NAME.APPROVED]: "approved_date",
          [TAB_NAME.REJECTED]: "requested_date2",
        };

        const excludedColumn = columnMap[keyToUpdate];

        const relevantColumns = new Set(Array.from(DEFAULT_SORT_COLUMNS).filter(col => col !== excludedColumn));

        if (sortGlobal.sortOrder === "desc" && relevantColumns.has(sortGlobal.sortColumn)) {
          const newSortColumn = columnMap[keyToUpdate];
          if (newSortColumn) {
            setSortGlobal((prevSort) => ({
              ...prevSort,
              sortColumn: newSortColumn,
              sortOrder: "desc",
            }));
            return;
          }
        }

        if (["requested_date", "requested_date2", "report_submitted_date", "approved_date"].includes(sortGlobal.sortColumn)) {
          setSortGlobal((prevSort) => ({
            ...prevSort,
            sortColumn: "assignment_created_date",
            sortOrder: "desc",
          }));
        }
  }

      const menuArchivedStudyRequesttabs = {
        shouldFocusOnMount: true,
        items: [
            {
            key: 'pending',
            className: 'menuPropListItem',
            // iconProps: { iconName: 'delete' },
            style: {backgroundColor:archivedStudyRequestTab.data.id == "pending"?'#80808085':'unset'},
            text: 'Pending',
            title: 'Pending',
            onClick: () => {
                handleArchivedStudyRequestTabChange("pending",ARCHIVED_STUDY_TABS.pending)
            }
           },
          {
            key: 'approved',
            // iconProps: { iconName: 'delete' },
            className: 'menuPropListItem',
            style: {backgroundColor:archivedStudyRequestTab.data.id == "approved"?'#80808085':'unset'},
            text: 'Approved',
            title: 'Approved',
           onClick: () => {
            handleArchivedStudyRequestTabChange("approved",ARCHIVED_STUDY_TABS.approved)
           }
          },
          {
            key: 'rejected',
            className: 'menuPropListItem',
            // iconProps: { iconName: 'delete' },
            style: {backgroundColor:archivedStudyRequestTab.data.id == "rejected"?'#80808085':'unset'},
            text: 'Rejected',
            title: 'Rejected',
           onClick: () => {
              handleArchivedStudyRequestTabChange("rejected",ARCHIVED_STUDY_TABS.rejected)
           }
          }, 
        ]
      };

      const menuForClosedAndReverted = (
        showClosed,
        showReverted,
        setAlertSuccessModal,
        alertSuccessModal,
        item,
        handleRevertCloseStudyModal,
        handleSendReport
        ) => {
        // console.log("--- Show CLosed ---",setAlertSuccessModal)

        
        let items = [];
        if(showClosed){
            items.push({
                key: 'closed',
                className: 'menuPropListItem',
                iconProps: {iconName: 'ReturnStudyIcon',className: 'study-list-action-icon-class'},
                text: 'Closed Reasons',
                title: 'Closed Reasons',
                onClick: () => {
                  // console.log("--- Opening ----",item.closingReason);
                    setAlertSuccessModal(()=>{
                        const newItem = {...alertSuccessModal};
                        newItem.show = true;
                        newItem.heading = "Closing Reasons";
                        newItem.isError = false;
                        newItem.isSuccess = false;
                        newItem.isWarning = true;
                        newItem.description = item.closingReason;
                        return newItem;
                      });
                }
                });
          }
        if(showReverted){
            items.push({
                key: 'revert',
                className: 'menuPropListItem',
                iconProps: { iconName: 'RevertCloseStudyIcon',className: 'study-list-action-icon-class' },
                text: 'Revert Closed Study',
                title: 'Revert Closed Study',
                onClick: () => {
                    handleRevertCloseStudyModal(item)
                }
                });
          }

          if(item?.reportDoneStatus == 2){
            items.push({
              key: 'sendReport',
              className: 'menuPropListItem',
              iconProps: {iconName: item?.notificationSent?'UnSendMailIcon':'MailIcon',className: 'study-list-action-icon-class'},
              text: 'Send Report',
              title: 'Send Report',
              onClick: () => {
                 handleSendReport();
                 setShowSendReportModal(()=>{
                  const newItem = {...showSendReportModal};
                  newItem.show = true;
                  newItem.firmId = item?.firmId;
                  newItem.clientId = item?.clientId;
                  return newItem;
                 })
              }
              });
          }
          return items;
        };

        const checkForConditionRequired = (val) => {
            if(val != null && val != undefined){
              return true;
            }else{
              return false
            }
          }

          const fetchData = async (options) => {
            setApplyClick(false);
            let pageIndex = options.pageIndex;
            let pageSize = options.pageSize;
            let sortColumn = options.sortObj.sortColumn;
            let sortOrder = options.sortObj.sortOrder;
            
            let id = options.id;
        
            let searchDtoVar = searchDto;
            if (
              searchDtoVar.modalityIds != null &&
              searchDtoVar.modalityIds.length == 0
            ) {
              searchDtoVar.modalityIds = null;
            }
            if (
                searchDtoVar.subModalityIds != null &&
                searchDtoVar.subModalityIds.length == 0
              ) {
                searchDtoVar.subModalityIds = null;
              }
            let dto = { ...searchDtoVar };
            dto = updateDto(dto, id, pageIndex, sortColumn, sortOrder, selectedValue);
            delete dto.activeSubTab;
            if (options.subTabId === "resubmission") {
                dto["activeSubTab"] = "resubmission";
              }   

              
            dto["pageSize"] = pageSize;
            dto["showCount"] = showCount ? 1 : 0;
            let body = {
              studyListSearchDto: dto,
            };
            let response = null;
            setStudyListLoading(true);
            studyListRef?.current?.continuousStart();
            let data = null;
            let totalCount = null; 
          try{
            if(id === TAB_NAME.UNREPORTED && firstTimeLoading){
              response = {
                status : 200,
                data : {
                  result : "SUCCESS",
                  data : filterInputValues
                }
              }
            }else{
              response = await getStudyListByTab(body, id);            }
            if (response.status === 200 && response.data.result === "SUCCESS") {
             // setStudyListLoading(false);
              studyListRef.current.complete();
              setStudyListReloadCounter(prev=>prev+1);
              setShowClientName(response.data.data.showClientName);
              setShowReferringPhysician(response?.data?.data?.showReferringPhysician);
              setIsTypistWorkflowEnabled(response.data.data.isTypistWorkflowEnabled);
              setEnableHistoryUpload(response.data.data.enableHistoryUpload||false);
              setAllowDeleteStudy(response.data.data.allowDeleteStudy||false);
              setAllowStudyEdit(response.data.data.allowStudyEdit||false);
              setShowAddStudy(response.data.data.showAddStudy);
              setShowChats(response.data.data.showChats);
              setShowHistory(response.data.data.showHistory);
              setShowViewer(response.data.data.showViewer);
              setShowAiResults(response.data.data.showAiResult);
              setShowSavedReport(response.data.data.showSavedReport);
              setStudyListModalAuditEnabled(!!response?.data?.data?.studyListModalAuditEnabled);
              setPositive(response.data.data.positive);
              setTwoMonitorEnabled(response.data.data.twoMonitorEnabled);
              data = handleSucessDataAndCount(id, response, data, totalCount).data;
              returnedStudyCountApiFunc({ rows: data });
              setStudyListSearchDateFilterValue(response?.data?.data?.user?.studylistSearchDateFilter);
              setStudylistOrderBy(response?.data?.data?.user?.studylistOrderBy != null ? Number(response.data.data.user.studylistOrderBy) : 1);
              const userNoOfImagesFilter1 = response?.data?.data?.user?.noOfImagesFilter;
              if (userNoOfImagesFilter1 != null) {
                setPreferenceNoOfImagesFilter(userNoOfImagesFilter1);
              }
        
              totalCount = handleSucessDataAndCount(
                id,
                response,
                data,
                totalCount
              ).totalCount;
              setTotalRecordCount(prevState => ({
                ...prevState,
                [options.totalCountKey || id]: totalCount
              }));            
              setSearchResultLength(handleSucessDataAndCount(
                id,
                response,
                data,
                totalCount
              ).data?.length);
            }else{
              setStudyListLoading(false);
              studyListRef.current.complete();
              setShowModal(()=>{
                const newItem = {...showModal};
                newItem.appFailer = true;
                newItem.description = t("string-literals.error-msg");
                return newItem;
              }); 
              return {
                rows: [],
                pageCount: 1,
              };  
            }}catch(e){
              setStudyListLoading(false);
              studyListRef.current.complete();
              setShowModal(()=>{
                const newItem = {...showModal};
                newItem.appFailer = true;
                newItem.description = t("string-literals.error-msg");
                return newItem;
              });    
              return {
                rows: [],
                pageCount: 1,
              };
            }
        
            return {
              rows: data,
              pageCount: Math.ceil(totalCount / pageSize),
            };
          };

          const fetchDataMobile = async (options) => {
            // console.log("--- Calling FetchDataMobile ---",options)
            setApplyClick(false);
            let pageIndex = options.pageIndex;
            let pageSize = options.pageSize;
            let sortColumn = options.sortObj.sortColumn;
            let sortOrder = options.sortObj.sortOrder;
            let id = options.id;
        
            let searchDtoVar = searchDto;
            if (
              searchDtoVar.modalityIds != null &&
              searchDtoVar.modalityIds.length == 0
            ) {
              searchDtoVar.modalityIds = null;
            }
            if (
                searchDtoVar.subModalityIds != null &&
                searchDtoVar.subModalityIds.length == 0
              ) {
                searchDtoVar.subModalityIds = null;
              }
            let dto = { ...searchDtoVar };
            dto = updateDto(dto, id, pageIndex, sortColumn, sortOrder, selectedValue);
            delete dto.activeSubTab;
            if (selectedValue === "study_25") {
              dto["activeSubTab"] = "resubmission";
            }
        
            dto["pageSize"] = pageSize;
            dto["showCount"] = showCount ? 1 : 0;
            let body = {
              studyListSearchDto: dto,
            };
            let response = null;
            setStudyListLoading(true);
            studyListRef?.current?.continuousStart();
            // console.log("--- Bool Check ----",id === TAB_NAME.UNREPORTED," ",firstTimeLoading," ",filterInputValues);
            let data = null;
            let totalCount = null; 
            try{if(id === TAB_NAME.UNREPORTED && firstTimeLoading){
              response = {
                status : 200,
                data : {
                  result : "SUCCESS",
                  data : filterInputValues
                }
              }
            }else{
              //console.log("--- @@@ Tab Fetch ----");
              response = await getStudyListByTab(body, id);
            }
            if (response.status === 200 && response.data.result === "SUCCESS") {
              setStudyListLoading(false);
              studyListRef.current.complete();
              setStudyListReloadCounter(prev=>prev+1);
              setShowClientName(response?.data?.data?.showClientName);
              setIsTypistWorkflowEnabled(response?.data?.data?.isTypistWorkflowEnabled)
              setEnableHistoryUpload(response.data.data.enableHistoryUpload||false);
              setAllowDeleteStudy(response.data.data.allowDeleteStudy||false);
              setAllowStudyEdit(response.data.data.allowStudyEdit||false);
              setShowAddStudy(response.data.data.showAddStudy);
              setShowChats(response.data.data.showChats);
              setShowHistory(response.data.data.showHistory);
              setShowViewer(response.data.data.showViewer);
              setShowAiResults(response.data.data.showAiResult);
              setShowSavedReport(response.data.data.showSavedReport);
              setStudyListModalAuditEnabled(!!response?.data?.data?.studyListModalAuditEnabled);
              setTwoMonitorEnabled(response.data.data.twoMonitorEnabled);

              setShowReferringPhysician(response?.data?.data?.showReferringPhysician);
              data = handleSucessDataAndCount(id, response, data, totalCount).data;
              setStudyListSearchDateFilterValue(response?.data?.data?.user?.studylistSearchDateFilter);
              setStudylistOrderBy(response?.data?.data?.user?.studylistOrderBy != null ? Number(response.data.data.user.studylistOrderBy) : 1);
              const userNoOfImagesFilter2 = response?.data?.data?.user?.noOfImagesFilter;
              if (userNoOfImagesFilter2 != null) {
                setPreferenceNoOfImagesFilter(userNoOfImagesFilter2);
              }
        
              totalCount = handleSucessDataAndCount(
                id,
                response,
                data,
                totalCount
              ).totalCount;
              setTotalRecordCount(prevState => ({
                ...prevState,
                [options.totalCountKey || id]: totalCount
              }));
              setSearchResultLength(handleSucessDataAndCount(
                id,
                response,
                data,
                totalCount
              ).data?.length);
            }else{
              setStudyListLoading(false);
              studyListRef.current.complete();
                setShowModal(()=>{
                  const newItem = {...showModal};
                  newItem.appFailer = true;
                  newItem.description = t("string-literals.error-msg");
                  return newItem;
                }); 
                return {
                  rows: [],
                  pageCount: 1,
                };  
            }}catch(e){
              setStudyListLoading(false);
              studyListRef.current.complete();
              setShowModal(()=>{
                const newItem = {...showModal};
                newItem.appFailer = true;
                newItem.description = t("string-literals.error-msg");
                return newItem;
              });    
              return {
                rows: [],
                pageCount: 1,
              };  
            }
        
            return {
              rows: data,
              pageCount: Math.ceil(totalCount / pageSize),
            };
          };

          const handleChangeSizeIndex = (index, size, id) => {
            let resolvedId = id;
            if(resolvedId == ""){
              resolvedId = getCurrentActiveTabId(tabDetails(roles, selectedValue,themeName,unreportedAllTabs, peerReviewAssignedTab, contextSwitchUser, qcReviewer, qcOutsourceLogin, peerReviewAdmin, peerReviewEvaluator, archivedStudyRequestTab, savedAllTabs, reportedAllTabs, qcReviewAllTabs),selectedValue)
            }
            if (paginationObj[resolvedId]?.pageIndex === index && paginationObj[resolvedId]?.pageSize === size) {
              return;
            }
            let tempPaginationObj = {};
            for (const key in paginationObj) {
              if (key == resolvedId) {
                tempPaginationObj[key] = {
                  pageIndex: index,
                  pageSize: size,
                };
              } else {
                tempPaginationObj[key] = paginationObj[key];
              }
            }
            setPaginationObj(tempPaginationObj);
          };

          const handleRefresh = () => {
            //handleChangeSizeIndex(0,50,"");
            // let filterUpdated = filterApplied + 1;
            // setFilterApplied(filterUpdated);
            setResetRowSelection(true);
            setStoreFilterBadges(filterBadges);
            setProviderDdlList({});
            // returnedStudyCountApiFunc();
            // dataQueryState.refetch();
            //  returnedStudyCountApiFunc();
            setTimeout(() => {
              let filterUpdated = filterApplied + 1;
              setFilterApplied(filterUpdated);
            }, 100);
            setRunPaginationAlgo(prev => !prev);
          };

          const unassignProvider = async (data,rest,setLoadingLockUnlock,handleRowUpdateForLock,currentIndex) => {
            const body = {
              reportingProvider: {
                studyId: rest.row.original.id,
                clientId: rest.row.original.assignmentList[currentIndex].clientId,
                firmId: rest.row.original.assignmentList[currentIndex].firmId,
                assignedProviderId: rest.row.original.assignmentList[currentIndex].providerId,
              },
              isAssign: false,
            };
            setLoadingLockUnlock(true);
            const response = await assignMe(body);
            if (response.status === 200 && response.data.result === "SUCCESS") {
              //ref.current.complete();
              showToastv2(TOAST_TYPE.SUCCESS, "Study unassigned successfully");
              handleRowUpdateForLock(data, "", false,currentIndex);
              setLoadingLockUnlock(false);
            } else {
              //ref.current.complete();
              showToastv2(TOAST_TYPE.ERROR, "Study not unassigned successfully");
              setLoadingLockUnlock(false);
            }
          };

      const handleUpdateDataQueryStateProviderList = (list,studyId) => {

        const objectExists = providerDdlList.hasOwnProperty(studyId);
        if (!objectExists) {
          setProviderDdlList((prevDdlList) => ({
            ...prevDdlList,
            [studyId]: list,
          }));
        }
      }

      const handleDesktopClearFilter = () => {
        setFilterBadges([]);
        const defaultSortColumn = !TABS_WITH_SPECIFIC_SORT.includes(selectedValue) && studylistOrderBy === 2
          ? "emergency_status"
          : "assignment_created_date";
        setSortGlobal({
          sortColumn: defaultSortColumn,
          sortOrder: "desc",
        });
        setNoOfImagesfilter(null);
        setReportDateFrom(new Date());
        setReportDateTo(new Date());
        setSearchDto(initSearchDto);
      };

      const handleMobileClearFilter = () => {
        setStoreFilterBadges([]);
        setFilterBadges([]);
        const defaultSortColumn = !TABS_WITH_SPECIFIC_SORT.includes(selectedValue) && studylistOrderBy === 2
          ? "emergency_status"
          : "assignment_created_date";
        setSortGlobal({
          sortColumn: defaultSortColumn,
          sortOrder: "desc",
        });
        setNoOfImagesfilter(null);
        setStudyDateFrom(null);
        setStudyDateTo(new Date());
        setReportDateFrom(new Date());
        setReportDateTo(new Date());
        // handleChangeSizeIndex(0,50,"");
        setTimeout(()=>{
          setPatientNameBadgeShow(false);
          setSearchDto(initSearchDto);
          handleChangeSizeIndex(0,50,"");
        }, 100);
    
        setTimeout(() => {
          let filterUpdated = filterApplied + 1;
          setFilterApplied(filterUpdated);
        }, 200);
      };

      const fetchCsvDownload = async () => {
        const response = await (exportType === 'excel' ? fetchExcelDownloadProgress(csvToken) : fetchCsvDownloadProgress(csvToken));
        if (response.status !== 200) return 0;

        if (response.data.data.status === "FAILED") {
          showToastv2(
            TOAST_TYPE.ERROR,
            response.data.data.error
              ? response.data.data.error
              : "Failed to download file."
          );
          hideProgressAfterDelay();
          return 100;
        }

        const progress = response.data.data.progress;
        setStudyCsvProgress(progress);
        updateProgress(studyCsvProgressId, progress);

        if (progress >= 100) {
          await downloadFile(csvToken);
        }

        return progress;
      };

      const hideProgressAfterDelay = () => {
        setTimeout(() => {
          hideProgress(studyCsvProgressId);
          setStudyCsvProgress(0);
        }, 3000);
      };

      const downloadFile = async (token) => {
        const response = await (exportType === 'excel' ? downloadCompletedExcelFile(token) : downloadCompletedCsvFile(token));
        if (response.status === 200) {
          const file = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          const url = window.URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", getFileName(response));
          document.body.appendChild(link);
          link.click();
          link.remove();
          showToastv2(TOAST_TYPE.SUCCESS, "Export CSV downloaded");
          updateProgress(studyCsvProgressId, 100);
        } else {
          showToastv2(TOAST_TYPE.ERROR, "Error while downloading report.");
        }
        hideProgressAfterDelay();
      };

      const getFileName = (response) => {
        var disposition = response.headers["content-disposition"];
        var filename = "demo.zip";
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
        return filename;
      };

      const patientIdBasedSearch = (val) => {
        
        if( val != null &&
          val.length > 0){
            handleChangeSizeIndex(0,50,"");
            setPatientNameBadgeShow(true);
            let searchTrimmedData = val.trim();
            setTimeout(()=>{
              
            })
            setSearchDto({...searchDto, patientNameOrId:searchTrimmedData });
            let filterUpdated = filterApplied + 1;
            setFilterApplied(filterUpdated);
    
          }
      }
        const setNoOfImagesIds = (name, id, checkStatus) => {
            if (checkStatus) {
              const newBadges = filterBadges.filter(item => item.key !== "noOfImages");
              newBadges.push({ key: "noOfImages", label: name, value: id });
              setFilterBadges(newBadges);
              setSearchDto(prev => ({
                ...prev,
                noOfImages: id
              }));
            } else {
              const newBadges = filterBadges.filter(item => item.key !== "noOfImages");
                setFilterBadges(newBadges);
                setSearchDto(prev => ({
                  ...prev,
                  noOfImages: null   
                }));
            }
          };
            const setHistoryIds = (name, id, checkStatus) => {
              if (checkStatus) {
                setFilterBadges([
                  ...filterBadges.filter(item => item.key !== "historyChecks"),
                  {
                    key: "historyChecks",
                    label: name,
                    value: id
                  }
                ]);
                setSearchDto(prev => ({ ...prev, historyChecks: id }));
              } else {
                setFilterBadges(filterBadges.filter(item => item.key !== "historyChecks"));

                setSearchDto(prev => ({ ...prev, historyChecks: null }));
              }
            };

      // useEffect(()=>{
      //   console.log("---SearchDto---",searchDto);
      // },[searchDto]);

    const handleBlitzReporting = () => {
      let url = `/new/blitz/reporting?filter=${studyBlitzFilter}`;
      let w = window.open(url, "_blank");
      return;
    };

    return (
        <studylistContext.Provider
            value={{
                studyCounts,
                searchDto,
                setSearchDto,
                setHospital,
                setModality,
                selectedStudies,
                // setSelectedAllStudies,
                setSelectedStudies,
                // selectedAllStudies,
                studyData,
                setStudyData,
                // addAllStudies,
                updateSelectedStudies,
                columns,
                roles,
                userId,
                allStudies,
                statePagination, setStatePagination,
                sortGlobal, setSortGlobal,
                filterInputValues,
                storefilterInputValues,
                setStoreFilterInputValues,
                setFilterInputValues,
                showFilters,setShowFilters,

                setModalityIds,
                setSubModalityIds,
                setClassificationIds,
                setClientOrFirmIds,
                setNoOfImagesIds,
                setHistoryIds,
                setUploadDate,
                setPathology,
                setPriority,
                setProviderIds,
                setStudyDate,
                setPatientDetail,
                setOrderId,
                setAccessionNumber,
                setKeyword,
                setStudyDescription,
                applyClick,setApplyClick,
                filterBadges,
                setFilterBadges,
                removeBadgeFromFilter,
                storefilterBadges,
                setStoreFilterBadges,
                trackApplyButton,
                setTrackApplyButton,
                fullClientFirmList,
                minimalClientFirmList,
                clientFirmList,
                patientNameBadgeShow,
                setPatientNameBadgeShow,
                returnedReasonCount,
                showCommunicationModal, 
                setShowCommunicationModal,
                hideModal,
                showReturnedStudyReasonModal, 
                setShowReturnedStudyReasonModal,
                showCount, 
                setShowCount,
                refreshRequired, setRefreshRequired,
                storedRows, setStoredRows,
                studyListLoading, setStudyListLoading,
                studyListRef,
                showClientName, setShowClientName,
                showReferringPhysician, setShowReferringPhysician,
                isTypistWorkflowEnabled, setIsTypistWorkflowEnabled,
                enableHistoryUpload, setEnableHistoryUpload,
                allowDeleteStudy, setAllowDeleteStudy,
                allowStudyEdit, setAllowStudyEdit,
                showAddStudy,setShowAddStudy,
                showChats,setShowChats,
                showHistory,setShowHistory,
                showViewer,setShowViewer,
                showAiResults,setShowAiResults,
                showSavedReport,setShowSavedReport,
                studyListModalAuditEnabled, setStudyListModalAuditEnabled,

                showVersionModalForReport,setShowVersionModalForReport,
                dataQueryState, setDataQueryState,
                updateLockUnlockRows, setUpdateLockUnlockRows,
                searchResultLength, setSearchResultLength,
                handleEnterKeyPress,
                showGenericConfirmModal, setShowGenericConfirmModal,
                handleGenericConfirmModal,
                confirmMessage, setConfirmMessage,
                showDeleteModal, setShowDeleteModal,
                deleteStudyFunc,
                handleCloseDeleteModal,
                showDeleteSuccessModal, setShowDeleteSuccessModal,
                deleteSuccessMessage, setDeleteSuccessMessage,
                showReInferenceModal, setShowReInferenceModal,
                handleCloseReInferenceModal,
                handleBatchDelete,
                handleBatchReInference,
                menuItemsForBatchAndInference,
                rowSelectionState, setRowSelectionState,
                showConfirmModalState, setShowConfirmModalState,
                menuCXRtabs,
                menuSavedTabs,
                menuPeerReviewtabs,
                selectedValue, setSelectedValue,
                unreportedAllTabs,setUnreportedAllTabs,
                peerReviewAssignedTab, setPeerReviewAssignedTab,
                handlePeerReviewTabChange,
                archivedStudyRequestTab,setArchivedStudyRequestTab,
                menuForClosedAndReverted,
                handleCXRTabChange,
                handleSavedTabChange,
                handleArchivedStudyRequestTabChange,
                reportedAllTabs, setReportedAllTabs,
                handleReportedTabChange,
                qcReviewAllTabs, setQcReviewAllTabs,
                handleQCReviewTabChange,
                rowSelectedArray,setRowSelectedArray,
                getCountOfAbleToDeleteStudies,
                batchReinferenceAndDeleteArray, setBatchReinferenceAndDeleteArray,
                resetRowSelection,setResetRowSelection,
                searchResultLengthObj,setSearchResutLengthObj,
                filterApplied,setFilterApplied,
                alertSuccessStudyListState, setAlertSuccessModalStudyListState,
                checkForConditionRequired,
                fetchData,
                paginationObj, setPaginationObj,
                handleChangeSizeIndex,
                handleRefresh,
                returnedStudyCountApiFunc,
                trackOfVisisted, setTrackOfVisited,
                unassignProvider,
                setFirstTimeLoading,
                showShimmer,setShowShimmer,
                setReturnedReasonCount,
                handleUpdateDataQueryStateProviderList,
                providerDdlList,setProviderDdlList,
                showSendReportModal,setShowSendReportModal,
                fetchDataMobile,
                handleMobileClearFilter,
                handleDesktopClearFilter,
                assignmentChaiHoverPopupId,setAssignmentChaiHoverPopupId,
                studyDateFrom,setStudyDateFrom,
                studyDateTo,setStudyDateTo,
                changeToDropSorting, setChangeToDropSorting,
                showImageDeleteModal, setShowImageDeleteModal,
                handleBatchImageDelete,
                studyCsvProgress, setStudyCsvProgress,
                studyCsvProgressId, setStudyCsvProgressId,
                csvToken, setCsvToken,
                csvFetchInterval, setCsvFetchInterval,
                exportType, setExportType,
                showExportCsvModal, setShowExportCsvModal,
                showDownloadsModal, setShowDownloadsModal,
                showAddStudyModal, setShowAddStudyModal,
                showExportCsvConfirmModal, setShowExportCsvConfirmModal,
                noOfImagesFilter, setNoOfImagesfilter,
                preferenceNoOfImagesFilter,
                historyCheckFilter, setHistoryCheckFilter,
                patientIdBasedSearch,
                mobileAssignmentObject, setMobileAssignmentObject,
          allDataElement, setAllDataElement,
          totalRecordCount, setTotalRecordCount,
          activeTab, setActiveTab,
          runPaginationAlgo,
          maintenance,
          setMaintenance,
          setReportDate,
          reportDateFrom,setReportDateFrom,
          reportDateTo, setReportDateTo,
          studyListSearchDateFilterValue, setStudyListSearchDateFilterValue,
          uploadDateRange,
          twoMonitorEnabled, setTwoMonitorEnabled,
          tabBadgeState,
          studyCountLoading,
          savedAllTabs,
          maxBulkReportDownload,
          handleBatchReportDownload,
          xrayReportType, setXrayReportType,
          nonXrayReportType, setNonXrayReportType,
          handleBlitzReporting,
          studyBlitzFilter, setStudyBlitzFilter,
          imageUploadStatusMap, setImageUploadStatusMap,
          studylistOrderBy,
            }}
        >
            {props.children}
        </studylistContext.Provider>
    )
}

export default StudylistState;